import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../../shared/logging/customerLogger.js';

export const qrLog = createScopedLogger(customerLogger, { module: 'checkout', feature: 'qr' });
export const sessionLog = createScopedLogger(customerLogger, { module: 'checkout', feature: 'session' });
